import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IconSectionProps {
	show: boolean
	config: {
		color: string
		mainIcon: IconDefinition
		subIcon?: IconDefinition
		iconSpin?: boolean
	}
	children?: any
}

const IconSection: React.FunctionComponent<IconSectionProps> = ({
	show,
	config,
	children,
}: IconSectionProps) => {
	return (
		<div
			className={`p-4 flex py-8 left-0 top-0 h-full w-full flex-col items-center text-center ${
				!show ? 'hidden' : ''
			}`}
		>
			<div className="flex items-center mb-4">
				<FontAwesomeIcon
					icon={config.mainIcon}
					className={`text-4xl mr-2 ${config.color}`}
				/>
				{config.subIcon ? (
					<FontAwesomeIcon
						icon={config.subIcon}
						spin={config.iconSpin || false}
						className={`text-xl rounded-full -ml-6 -mt-6 bg-white p-1 ${config.color}`}
					/>
				) : null}
			</div>
			{children || null}
		</div>
	)
}

export default IconSection
